import { Center, Text } from "@chakra-ui/react";
import { ErrorBoundaryFallbackProps } from "@suspensive/react";
import { AppChakraProvider } from "app/provider/AppChakraProvider";
import React from "react";
import Page from "shared/components/layout/Page";
import PageBody from "shared/components/layout/PageBody";
import PageContainer from "shared/components/layout/PageContainer";
import PageContent from "shared/components/layout/PageContent";
import PageNav from "shared/components/layout/PageNav";
import Logo from "shared/img/logo.svg?react";

export const IndexError: React.FC<ErrorBoundaryFallbackProps> = ({ error }) => (
  <AppChakraProvider>
    <Page>
      <PageNav>
        <Logo />
      </PageNav>
      <PageContainer>
        <PageContent isFullHeight={true}>
          <PageBody>
            <Center flex={1}>
              <Text>{error.message}</Text>
            </Center>
          </PageBody>
        </PageContent>
      </PageContainer>
    </Page>
  </AppChakraProvider>
);
